import { AxiosError } from 'axios'
import { ENDPOINT_SUPER_AGENT } from '../config'
import type { SuperAgentStatusResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const getSuperAgentStatus = async (
  workspaceSlug: string,
  projectId: string,
): Promise<SuperAgentStatusResponse> => {
  try {
    const response = await AuthAxios.get<SuperAgentStatusResponse>(
      `${ENDPOINT_SUPER_AGENT}/${workspaceSlug}/projects/${projectId}/super-agent`,
    )
    return response.data
  } catch (error) {
    // AI disabled for the workspace, or no permission — treat as "not enabled".
    if (error instanceof AxiosError && (error.response?.status === 403 || error.response?.status === 404)) {
      return { enabled: false }
    }
    throw error
  }
}

export default getSuperAgentStatus
